<template>
  <div
    v-if="pageShow && envShow"
    ref="page"
    v-exposure="`code=${data.name}_sw`"
    :class="['zeus-content-page', isFlow ? 'zeus-content-page-static' : '', data.name]"
    :style="getPageStyles()"
    @click="closeBackPop($event)"
  >
    <template v-for="(component) in data.components">
      <component-group
        v-if="component.type === 'group'"
        :key="component.id"
        :data="component.children"
        :page="data"
        :is-fixed-parent="isFixed && !isFixedParent"
      />
      <zeus-component
        v-else
        :key="component.id"
        :data="component"
        :page="data"
        :is-fixed-parent="isFixed && !isFixedParent"
      />
    </template>
  </div>
</template>

<script>
import { renderBg, isMobile } from '@/utils/tools'
import ComponentGroup from './componentGroup'
import { BsGetEnv, BsUtil, BsGetCid, BsGetXcx } from 'dida-web-common'
import ZeusComponent from './component'

export default {
  components: { ComponentGroup, ZeusComponent },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  inject: ['globalConfig'],
  data() {
    return {
      fixedData: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        zIndex: 3000,
        pointerEvents: 'none'
      },
      envShow: false,
      pageShow: this.data.name === 'loading',
      origin: this.getOrigin()
    }
  },
  computed: {
    layoutType() {
      return this.data?.options?.basic?.layoutType
    },
    style() {
      return this.data?.options?.style
    },
    isFixed() {
      return this.layoutType === 'fixed'
    },
    isFlow() {
      return this.layoutType === 'static'
    },
    // isMobile() {
    //   return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(window.navigator.userAgent)
    // },
    isFixedParent() {
      const { background } = this.style || {}
      const { color, image } = background || {}
      if (image) return true
      if (!color || color === 'transparent' || color.split(',').pop() === '0)') {
        return false
      }
      return true
    }
  },
  watch: {
    '$route': {
      handler: 'handleRouteChange',
      immediate: true
    },
    'pageShow': {
      handler() {
        const { bodyScroll } = this.data?.options?.basic
        if (bodyScroll) {
          if (this.envShow && this.pageShow) {
            document.body.style.overflow = 'hidden'
          } else {
            // console.log(2222228811, bodyScroll, this.envShow, this.pageShow)
            document.body.style.overflow = ''
          }
        }
        // if (bodyScroll && this.envShow && this.pageShow) {
        //   document.body.style.overflow = 'hidden'
        // } else {
        //   // console.log(2222228811, bodyScroll, this.envShow, this.pageShow)
        //   document.body.style.overflow = ''
        // }
      }
      // immediate: true
    }
  },
  async mounted() {
    this.initEvents()
    this.$bus.$on('logined', () => {
      this.setEnvShow()
    })
  },
  async created() {
    this.handlerFixedScroll()
    this.setEnvShow()
    if (this.data.name !== 'loading') {
      this.pageShow = await this.setPageShow()
    }
  },
  methods: {
    closeBackPop(e) {
      const { options = {}} = this.data || {}
      const { basic = {}} = options
      const { pageRouter, closeBackPop: shouldClose } = basic
      if (this.isFixed && this.isFixedParent && shouldClose && e.target === this.$refs.page && !pageRouter) {
        this.pageShow = false
      }
    },
    // 什么环境展示、登录是否展示
    async setEnvShow() {
      const { options = {}} = this.data || {}
      const { basic = {}} = options
      const { showPage } = basic
      if (!BsUtil.isObject(showPage)) { // 历史逻辑
        this.envShow = true
        return
      }
      // 页面路由没有关系
      // if (showPage.env > 5) {
      //   const role = BsUtil.queryString('role')
      //   this.envShow = (showPage.env === 6 && role === '1') || (showPage.env === 7 && role === '2')
      //   return
      // }
      const role = BsUtil.queryString('role')
      // 和路由没有关系
      const { isAli, isWx } = await BsGetXcx()
      const shouldShowEnv = (
        showPage.env === 1 ||
        showPage.env === 2 ||
        (showPage.env === 3 && BsGetEnv.inApplication) ||
        (showPage.env === 4 && (isAli || isWx)) ||
        (showPage.env === 5 && !BsGetEnv.inApplication && !(isAli || isWx)) ||
        (showPage.env === 6 && role === '1') ||
        (showPage.env === 7 && role === '2')
      )
      if (shouldShowEnv) {
        // 和登录有关系
        this.envShow = await this.shouldShowBasedOnLogin(showPage)
      } else {
        this.envShow = false
      }
    },
    async shouldShowBasedOnLogin(showPage) {
      const loginCondition = showPage?.login
      if (loginCondition === 1) return true
      const { cid } = await BsGetCid()
      return loginCondition === 2 ? !!cid : loginCondition === 3 ? !cid : true
    },
    async setPageShow() {
      const { options = {}} = this.data || {}
      const { basic = {}} = options
      const { showPage } = basic
      if (BsUtil.isBoolean(showPage)) return showPage // 兼容历史逻辑
      if (showPage?.env === 1) return true
      if (showPage?.env === 2) return false
      return true
    },
    initEvents() {
      const { options = {}} = this.data || {}
      const { action = [] } = options
      if (action.length === 0) return
      action.forEach(({ handler: actionHandler, params = {}, options: { data } = { data: '' }, subscribe = [] }) => {
        subscribe.forEach((subscription) => {
          this.$bus.$on(subscription, (triggerParams) => {
            this.handleAction(actionHandler, params, data, triggerParams)
          })
        })
      })
    },
    handleAction(handler, params, data, triggerParams) {
      switch (handler) {
        case '$h_hide':
          this.pageShow = false
          break
        case '$h_show':
          this.pageShow = true
          break
        default:
          break
      }
    },
    getPageStyles() {
      const fixedConfig = this.getFixedConfig()
      // const editAndFlowConfig = {}
      const height = this.getPageHeight()
      return {
        height,
        overflow: this.isFixed ? 'visible' : 'hidden',
        ...renderBg(this.style?.background || {}, this.$root.isSuWebp),
        ...fixedConfig
        // ...editAndFlowConfig
      }
    },
    getFixedConfig() {
      const fixedConfig = this.isFixed ? this.fixedData : {}

      if (this.isFixedParent && fixedConfig.position) {
        fixedConfig.position = 'fixed'
        fixedConfig.pointerEvents = 'auto'
      }
      return fixedConfig
    },
    getPageHeight() {
      if (this.isFixed) {
        return '100vh'
      }
      return this.isFlow ? 'auto' : this.handlerUnit(this.style?.height, this.style?.fs)
    },
    handlerUnit(v, fs = false) {
      if (fs) {
        return '100vh'
      }
      return isNaN(Number(v)) ? v : `${v}${this.globalConfig.unit}`
    },
    handlerFixedScroll() {
      if (this.isFixed && !isMobile) {
        this.fixedData.position = 'absolute'
        const handleScroll = () => {
          this.fixedData.top = `${document.documentElement.scrollTop || document.body.scrollTop}px`
        }
        window.addEventListener('scroll', handleScroll)
        this.$once('beforeDestroy', () => {
          window.removeEventListener('scroll', handleScroll)
        })
      }
    },
    handleRouteChange(to, from) {
      // const { options = {}} = this.data || {}
      // const { basic = {}} = options
      if (to.path !== '/') {
        this.$root.closeLoading = true
      }
    },
    getOrigin() {
      if (location.origin.indexOf('didachuxing.com') > -1) {
        return location.origin
      }
      if (BsGetEnv.isEnvOnline) {
        return 'https://web.didachuxing.com'
      }
      if (BsGetEnv.isEnvECS) {
        return 'https://web-simu.didachuxing.com'
      }
      return 'http://10.10.90.102:8080'
    }
  }
}
</script>
